import React from 'react'
import * as UI from 'ui'
import { Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe, Model, WhenModel } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'
import * as Displays from 'support/displays'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'

export default function LatestMessageDashboardWidget () {
  return (
    <Can permission='api.messages.messages.latest'>
      <Widget>
        <Translator namespace='dashboard.latest_message'>
          <Model resourceName='messages.messages' operationName='latest_undelivered' autoFetch>
            <SelectedDepartmentFilter />
            <WhenModel>
              <UI.Card purple className='relative'>
                <Pipeline>
                  <TriggerPipelineOnClick>
                    <div className='absolute right-4 top-4'>
                      <UI.Icons.Decline fill='white' className='w-3 h-3' />
                    </div>
                  </TriggerPipelineOnClick>
                  <ExecuteOperationForModelOnPipe resourceName='messages.messages' operationName='mark_as_read' />
                  <ExecuteOperationOnPipe resourceName='messages.messages' operationName='latest_undelivered' />
                </Pipeline>
                <UI.Collapsable>
                  <UI.Text color='lightgray' tag='div'>
                    <Displays.Html name='content_long' />
                  </UI.Text>
                </UI.Collapsable>
              </UI.Card>
            </WhenModel>
          </Model>
        </Translator>
      </Widget>
    </Can>
  )
}
